function Docs() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5 22h-16a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1zm-1-2V4h-14v16h14zM7.5 6h4v4h-4V6zm0 6h10v2h-10v-2zm0 4h10v2h-10v-2zm6-9h4v2h-4V7z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Docs;
